import React, { FC } from 'react';

import Link from 'styled/components/Link';
import { ListItem, Label, Arrow, StyledLink } from './style';

import { Color } from 'styled/theme/colors';
import { useTheme } from 'styled-components';

export type Props = {
  textColor?: Color;
  textColorActive?: Color;
  to: string;
  label: string;
  ariaLabel: string;
  disabled: boolean;
  showArrow: boolean;
  isActive?: boolean;
};

const Breadcrumb: FC<Props> = (props) => {
  const { palette } = useTheme();

  const {
    textColor = palette.text.secondary,
    textColorActive = palette.text.primary,
    to,
    label,
    ariaLabel,
    disabled,
    showArrow,
    isActive = false,
  } = props;

  const linkProps = {
    ariaLabel,
    disabled,
    to,
  };

  return (
    <>
      <ListItem as="li">
        <StyledLink
          as={disabled ? 'span' : Link}
          textColor={textColor}
          textColorActive={textColorActive}
          isActive={isActive}
          {...(disabled ? {} : linkProps)}
        >
          <div>
            <Label as="span" textColor={textColor}>
              {label}
            </Label>
          </div>
        </StyledLink>
      </ListItem>
      {showArrow && (
        <Arrow as="span" textColor={textColorActive} mx={0.5}>
          {'>'}
        </Arrow>
      )}
    </>
  );
};

export default Breadcrumb;
